export { InvestmentsServicesPage as default } from "@nvb/ui";
